import mock from "../../services/mock";

const call = () => {
  return mock.endpoint({
    data: {
      header: [
        {
          label: "Syariah",
          link: "#",
        },
        {
          label: "Solusi Untuk Anda",
          child: [
            {
              label: "Solusi Keseharian Anda",
              child: [
                {
                  label: "Kartu Kredit",
                  link: "#",
                },
                {
                  label: "Kartu Debit",
                  link: "#",
                },
                {
                  label: "Kartu Bukopin Prioritas",
                  link: "#",
                },
              ],
            },
            {
              label: "Solusi Masa Depan Anda",
              child: [
                {
                  label: "Simpanan",
                  link: "#",
                },
                {
                  label: "Pinjaman",
                  link: "#",
                },
                {
                  label: "Wealth Management",
                  link: "#",
                },
              ],
            },
            {
              label: "Solusi Untuk Bisnis Anda",
              child: [
                {
                  label: "UKM",
                  link: "#",
                },
                {
                  label: "Komersil",
                  link: "#",
                },
              ],
            },
            {
              label: "Layanan Terbaik Untuk Anda",
              child: [
                {
                  label: "Layanan Individu",
                  link: "#",
                },
                {
                  label: "Layanan Bisnis",
                  link: "#",
                },
              ],
            },
          ],
        },
        {
          label: "Tentang Kami",
          child: [
            {
              label: "Profil Bank Bukopin",
              child: [
                {
                  label: "Riwayat Singkat",
                  link: "#",
                },
                {
                  label: "Visi & Misi",
                  link: "#",
                },
                {
                  label: "Segmen Bisnis",
                  link: "#",
                },
                {
                  label: "Anak Perusahaan",
                  link: "#",
                },
                {
                  label: "Bidaya Perusahaan",
                  link: "#",
                },
                {
                  label: "Penghargaan",
                  link: "#",
                },
                {
                  label: "Bank Koresponden",
                  link: "#",
                },
                {
                  label: "Lembaga Profesi Perusahaan",
                  link: "#",
                },
                {
                  label: "Hubungi Kami",
                  link: "#",
                },
              ],
            },
            {
              label: "Struktur Manajemen",
              child: [
                {
                  label: "Komisaris",
                  link: "#",
                },
                {
                  label: "Direksi",
                  link: "#",
                },
                {
                  label: "Komite",
                  link: "#",
                },
                {
                  label: "Sekretaris Perusahaan",
                  link: "#",
                },
                {
                  label: "Struktur Organisasi",
                  link: "#",
                },
              ],
            },
            {
              label: "Hubungan Investor",
              child: [
                {
                  label: "Laporan Tahunan",
                  link: "#",
                },
                {
                  label: "Laporan Keuangan",
                  link: "#",
                },
                {
                  label: "RUPS",
                  link: "#",
                },
                {
                  label: "Riwayat Aksi Korporasi",
                  link: "#",
                },
                {
                  label: "Informasi Saham & Obligasi",
                  link: "#",
                },
                {
                  label: "Materi Investor",
                  link: "#",
                },
                {
                  label: "Kalender Acara",
                  link: "#",
                },
                {
                  label: "Kontak Hubungan Investor",
                  link: "#",
                },
              ],
            },
            {
              label: "Tanggung Jawab Sosial",
              child: [
                {
                  label: "Kebijakan Tanggung Jawab Sosial Perusahaan",
                  link: "#",
                },
                {
                  label: "Pelaksanaan Tanggung Jawab Sosial Perusaan",
                  link: "#",
                },
              ],
            },
            {
              label: "Tata Kelola Perusahaan",
              child: [
                {
                  label: "Tentang Tata Kelola Perusaan",
                  link: "#",
                },
                {
                  label: "Piagam",
                  link: "#",
                },
                {
                  label: "Pedoman",
                  link: "#",
                },
                {
                  label: "Laporan Tata Kelola",
                  link: "#",
                },
                {
                  label: "Kode Etik",
                  link: "#",
                },
                {
                  label: "Whistleblowing System",
                  link: "#",
                },
                {
                  label: "Pemberitahuan Privasi",
                  link: "#",
                },
              ],
            },
          ],
        },
        {
          label: "Info Terbaru",
          child: [
            {
              label: "Info Kurs",
              link: "#",
            },
            {
              label: "SBDK",
              link: "#",
            },
            {
              label: "News Room",
              child: [
                {
                  label: "Siaran Pers",
                  link: "/news-room",
                },
                {
                  label: "Berita",
                  link: "#",
                },
              ],
            },
            {
              label: "Pengumuman",
              link: "#",
            },
          ],
        },
        {
          label: "Jaringan",
          child: [
            {
              label: "Jaringan Kantor Bukopin",
              link: "#",
            },
            {
              label: "Lowongan Pekerjaan",
              link: "#",
            },
          ],
        },
        {
          label: "Karir",
          child: [
            {
              label: "Bekerja di Bukopin",
              link: "#",
            },
            {
              label: "Lowongan Pekerjaan",
              link: "#",
            },
          ],
        },
        {
          label: "Inspirasi Terkini",
          child: [
            {
              label: "Artikel Blog",
              link: "#",
            },
          ],
        },
        {
          label: "Layanan Nasabah",
          child: [
            {
              label: "Layanan Pengaduan",
              link: "/support-center",
            },
            {
              label: "Kontak Kami",
              link: "/contact-us",
            },
          ],
        },
      ],
      footer: [
        {
          title: "solusi_keseharian_anda",
          subdirectory: [
            {
              label: "kartu_kredit",
              link: "/credit-card",
            },
            {
              label: "kartu_debit",
              link: "/debit-card",
            },
            {
              label: "bukopin_prioritas",
              link: "/bukopin-priority",
            },
          ],
        },
        {
          title: "solusi_untuk_bisnis_anda",
          subdirectory: [
            {
              label: "UMKM",
              link: "/business-solution/umkm",
            },
            {
              label: "komersial",
              link: "/business-solution/komersial",
            },
          ],
        },
        {
          title: "karir",
          subdirectory: [
            {
              label: "life_at_bukopin",
              link: "/career-work",
            },
            {
              label: "jenjang_karir",
              link: "/career-work",
            },
            {
              label: "lowongan_pekerjaan",
              link: "/career-jobs",
            },
          ],
        },
        {
          title: "solusi_masa_depan_anda",
          subdirectory: [
            {
              label: "simpanan",
              link: "/savings",
            },
            {
              label: "pinjaman",
              link: "/loan",
            },
            {
              label: "wealth_management",
              link: "/wealth-management",
            },
          ],
        },
        {
          title: "layanan_terbaik_untuk_anda",
          subdirectory: [
            {
              label: "atm",
              link: "/network/atm",
            },
            {
              label: "safe_deposit_box",
              link: "/individu-service/2133",
            },
            {
              label: "lainnya",
              link: "/individu-service",
            },
          ],
        },
        {
          title: "current_inspiration",
          subdirectory: [
            {
              label: "lihat_artikel",
              link: "/inspiration",
            },
            {
              label: "promo_terbaik_bulan_ini",
              link: "/individu-service",
            },
          ],
        },
        {
          title: "layanan_nasabah",
          subdirectory: [
            {
              label: "layanan_pengaduan",
              link: "/support-center",
            },
          ],
        },
      ],
    },
  });
};

export default call;
